import { Content, Header, HeaderLabel, InfoCard, Link, Page, Breadcrumbs } from '@backstage/core-components';
import { Grid, Typography } from '@material-ui/core';

export const GlobalsHomePage = () => {
  return (
    <Page themeId="tool">
      <Header
        title="Event Taxonomy Reference Data (ETRD)"
        subtitle="Streamline feature tracking with event taxonomy-related guidance"
      >
        <HeaderLabel label="Owner" value="Data Reliability" />
        <HeaderLabel label="Slack" value="#data-reliability" />
      </Header>
      <Content>
        <InfoCard>
          <Grid container spacing={3} direction="column">
            <Grid item>
              <Breadcrumbs>
                <Link to="/dr-event-taxonomy-reference-data">Home</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item>
              <Typography variant="h5">Global Parameters</Typography>
            </Grid>
            <Grid item>
              <Link to="/dr-event-taxonomy-reference-data/globals/web">DirectSend Web Globals</Link>
            </Grid>
            <Grid item>
              <Link to="/dr-event-taxonomy-reference-data/globals/android">DirectSend Android Globals</Link>
            </Grid>
            <Grid item>
              <Link to="/dr-event-taxonomy-reference-data/globals/ios">DirectSend iOS Globals</Link>
            </Grid>
          </Grid>
        </InfoCard>
      </Content>
    </Page>
  );
};
